import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  profileSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  welcomeText: {
    color: "#1e40af",
    fontFamily: '"Euclid Circular B", sans-serif',
    fontWeight: 600,
    fontStyle: "normal",
    fontSize: 32,
    lineHeight: "100%",
    letterSpacing: "0%",
    verticalAlign: "middle",
    marginBottom: 8,
  },
  notificationIcon: {
    color: "#6b7280",
    cursor: "pointer",
    padding: theme.spacing(0.5),
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },
  profileAvatar: {
    backgroundColor: "#fbbf24",
    color: "#000",
    fontWeight: "bold",
  },
  welcomeCard: {
    background: "linear-gradient(135deg, #1162FE 0%, #4b95c8 100%)",
    borderRadius: 16,
    position: "relative",
    overflow: "hidden",
    minHeight: 200,
    boxShadow: "0 8px 24px rgba(17, 98, 254, 0.25)",
  },
  welcomeContent: {
    position: "relative",
    zIndex: 2,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: theme.spacing(3.5),
  },
  welcomeBgIcon: {
    position: "absolute",
    right: -18,
    top: -14,
    fontSize: 150,
    color: "rgba(255, 255, 255, 0.16)",
    zIndex: 1,
  },
  welcomeGlow: {
    position: "absolute",
    width: 160,
    height: 160,
    borderRadius: "50%",
    right: -40,
    bottom: -60,
    background: "rgba(255, 255, 255, 0.12)",
    zIndex: 1,
  },
  statsCard: {
    borderRadius: 14,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    minHeight: 100,
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      transform: "translateY(-2px)",
    },
  },
  statIcon: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
  },
  purpleIcon: {
    backgroundColor: "#ede9fe",
    color: "#8b5cf6",
  },
  blueIcon: {
    backgroundColor: "#dbeafe",
    color: "#3b82f6",
  },
  statValue: {
    fontSize: "1.75rem",
    fontWeight: "bold",
    color: "#1f2937",
    margin: theme.spacing(1, 0),
  },
  statChange: {
    fontSize: "0.875rem",
    color: "#10b981",
  },
  statChangeText: {
    fontSize: "0.875rem",
    color: "#9ca3af",
    marginLeft: theme.spacing(0.5),
  },
  appointmentsCard: {
    borderRadius: 16,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    height: 400,
  },
  appointmentHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  viewAllButton: {
    color: "#3b82f6",
    textTransform: "none",
    fontSize: "0.875rem",
  },
  appointmentAvatar: {
    backgroundColor: "#f3f4f6",
    color: "#6b7280",
  },
  appointmentTime: {
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  revenueCard: {
    borderRadius: 16,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    height: 400,
  },
  chartContainer: {
    height: 280,
    marginTop: theme.spacing(2),
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#1f2937",
  },
  cardTitle: {
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#1f2937",
  },
  customTypography: {
    fontFamily: '"Euclid Circular B", sans-serif',
    fontWeight: 550,
    fontStyle: "normal",
    fontSize: 24,
    lineHeight: "100%",
    letterSpacing: "0%",
    color: "#1f2937",
    verticalAlign: "middle",
  },

  welcomeAvatar: {
    width: 72,
    height: 72,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    color: "#1162FE",
    fontWeight: 700,
    fontSize: "1.7rem",
    marginBottom: theme.spacing(1.5),
    border: "3px solid rgba(255, 255, 255, 0.45)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)",
  },
  greetingText: {
    color: "rgba(255, 255, 255, 0.85)",
    fontSize: "1.25rem",
    fontWeight: 500,
  },
  welcomeName: {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1.2,
    marginBottom: theme.spacing(2),
  },
  apptCountPill: {
    display: "inline-flex",
    alignItems: "center",
    alignSelf: "flex-start",
    gap: theme.spacing(0.75),
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    color: "#1162FE",
    fontWeight: 600,
    fontSize: "1rem",
    padding: theme.spacing(1, 2),
    borderRadius: 999,
  },

  typeCard: {
    borderRadius: 16,
    border: "1px solid #eef0f3",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
    height: "100%",
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
      transform: "translateY(-2px)",
    },
  },
  typeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  typeIconWrap: {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  typeTitle: {
    fontSize: "1.05rem",
    fontWeight: 600,
    color: "#1f2937",
  },
  typeTotalLabel: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  typeTotalValue: {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#1f2937",
    lineHeight: 1.2,
    marginBottom: theme.spacing(2),
  },
  splitRow: {
    display: "flex",
    gap: theme.spacing(1.5),
  },
  splitPanel: {
    flex: 1,
    borderRadius: 12,
    padding: theme.spacing(1.5),
    textAlign: "center",
  },
  newPanel: {
    backgroundColor: "#eff6ff",
  },
  followPanel: {
    backgroundColor: "#f5f3ff",
  },
  splitPanelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  splitLabel: {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  splitValue: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: "#1f2937",
  },

  apptListItem: {
    borderRadius: 10,
    paddingLeft: 0,
    paddingRight: 0,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
  },
  onlineBadge: {
    backgroundColor: "#e7f7ee",
    color: "#0a8f54",
    fontWeight: 600,
    fontSize: "0.7rem",
    height: 22,
    textTransform: "capitalize",
  },
  offlineBadge: {
    backgroundColor: "#eef2ff",
    color: "#4f46e5",
    fontWeight: 600,
    fontSize: "0.7rem",
    height: 22,
    textTransform: "capitalize",
  },
  timeChip: {
    backgroundColor: "#f4f6f8",
    color: "#374151",
    fontWeight: 600,
    fontSize: "0.72rem",
    height: 24,
  },
  queueChip: {
    display: "inline-flex",
    alignItems: "center",
    marginTop: 4,
    padding: "2px 10px",
    borderRadius: 999,
    fontSize: "0.7rem",
    fontWeight: 700,
    lineHeight: 1.6,
  },
  startBtn: {
    backgroundColor: "#00897B",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.72rem",
    minWidth: 64,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#00796B",
    },
  },
  endBtn: {
    backgroundColor: "#1976D2",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.72rem",
    minWidth: 64,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#1565C0",
    },
  },
  apptSecondary: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  // Actual check-in / check-out times, next to the queue status.
  apptTimes: {
    fontSize: "0.72rem",
    fontWeight: 600,
    color: "#6b7280",
    marginTop: 4,
    whiteSpace: "nowrap",
  },
  apptMeta: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(0.5),
    flexShrink: 0,
  },
  apptMetaTime: {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#6b7280",
    whiteSpace: "nowrap",
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(5, 2),
    color: theme.palette.text.secondary,
  },
  emptyIcon: {
    fontSize: 44,
    color: "#cbd5e1",
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
